import { useEffect } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import cpfMask from "../../../../components/Formatters/cpfMask";

const useRepresentante = ({ formik: propsFormik, acaoFiscal }) => {
  const { request: representanteRequest, data: representanteData } = useApiClient();

  const { setValues, values } = propsFormik;

  const buscaRepresentante = () => {
    const parametro = { cpfRepresentante: values.cpfRepresentante, sqAcaoFiscal: acaoFiscal };

    representanteRequest(apiRoutes.fiscalizacao.ordemservico.consultaRepresentante, parametro);
  };

  const mascararCpf = () => {
    setValues((item) => ({
      ...item,
      cpfTestemunha: cpfMask(values.cpfTestemunha),
    }));
  };

  useEffect(() => {
    if (representanteData) {
      setValues((curr) => ({
        ...curr,
        cpfRepresentante: cpfMask(values.cpfRepresentante),
        nomeRepresentante: representanteData.result[0]?.nomeRepresentante
          ? representanteData.result[0]?.nomeRepresentante
          : "",
        cargoRepresentante: representanteData.result[0]?.cargoRepresentante
          ? representanteData.result[0]?.cargoRepresentante
          : "",
        isHabilitado: representanteData.result[0]?.nomeRepresentante.length > 0 ? 1 : 0,
      }));
    }
  }, [representanteData, setValues, values.cpfRepresentante]);

  return { buscaRepresentante, mascararCpf };
};

export default useRepresentante;
